// extracted by mini-css-extract-plugin
export var container = "Recent-module--container--VyPHF";
export var containerNarrow = "Recent-module--container-narrow--mkybq";
export var containerWide = "Recent-module--container-wide--g7vOy";
export var featured = "Recent-module--featured--Yy415";
export var featured__image = "Recent-module--featured__image--2ICcD";
export var featured__item = "Recent-module--featured__item--7cfZr";
export var featured__text = "Recent-module--featured__text--H8NHu";
export var fontDisplay = "Recent-module--font-display--zmzPG";
export var fontSansSerif = "Recent-module--font-sans-serif--q7Lmb";
export var hover = "Recent-module--hover--fcUnQ";
export var linkUl = "Recent-module--link-ul--5B2bq";
export var lock = "Recent-module--lock--OcnX8";
export var mainInner = "Recent-module--main-inner--sZQFc";
export var onlyForMedium = "Recent-module--only-for-medium--WJoIU";
export var onlyForSmall = "Recent-module--only-for-small--qB5RT";
export var others = "Recent-module--others--UTh2x";
export var others__list = "Recent-module--others__list--cG3aT";
export var pageTitleWrapper = "Recent-module--page-title-wrapper--BimZ8";
export var recent = "Recent-module--recent--peBLg";
export var recent__head = "Recent-module--recent__head--t+aD2";
export var root = "Recent-module--root--vWtWi";
export var spFull = "Recent-module--sp-full--qzFH2";
export var textCenter = "Recent-module--text-center--9qLkc";
export var textLeft = "Recent-module--text-left--Bslud";
export var textRight = "Recent-module--text-right--hQ8xc";